var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.75V12C11.25 11.8011 11.171 11.6103 11.0303 11.4697C10.8897 11.329 10.6989 11.25 10.5 11.25H7.5C7.30109 11.25 7.11032 11.329 6.96967 11.4697C6.82902 11.6103 6.75 11.8011 6.75 12V15.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3305 7.7325C13.1741 7.58283 12.966 7.49928 12.7496 7.49928C12.5331 7.49928 12.3251 7.58283 12.1687 7.7325C11.82 8.06514 11.3565 8.25072 10.8746 8.25072C10.3926 8.25072 9.92921 8.06514 9.58046 7.7325C9.42415 7.58305 9.21623 7.49964 8.99996 7.49964C8.7837 7.49964 8.57577 7.58305 8.41946 7.7325C8.07068 8.06536 7.60709 8.25107 7.12496 8.25107C6.64284 8.25107 6.17925 8.06536 5.83046 7.7325C5.67412 7.58283 5.46603 7.49928 5.24959 7.49928C5.03315 7.49928 4.82506 7.58283 4.66871 7.7325C4.33185 8.05396 3.88742 8.23858 3.42193 8.25041C2.95645 8.26225 2.50321 8.10046 2.15044 7.79653C1.79767 7.49261 1.57061 7.0683 1.51345 6.60618C1.45629 6.14407 1.57313 5.67722 1.84121 5.2965L4.00796 2.1585C4.14544 1.95563 4.33053 1.78954 4.54705 1.67475C4.76356 1.55995 5.0049 1.49995 5.24996 1.5H12.75C12.9943 1.49991 13.235 1.55951 13.451 1.67362C13.6671 1.78773 13.852 1.95289 13.9897 2.15475L16.161 5.29875C16.4291 5.67977 16.5458 6.14697 16.4883 6.60933C16.4308 7.07168 16.2032 7.49606 15.8498 7.79977C15.4965 8.10348 15.0428 8.26476 14.577 8.25218C14.1113 8.23961 13.6669 8.05408 13.3305 7.73175",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.21252V14.25C3 14.6478 3.15804 15.0294 3.43934 15.3107C3.72064 15.592 4.10218 15.75 4.5 15.75H13.5C13.8978 15.75 14.2794 15.592 14.5607 15.3107C14.842 15.0294 15 14.6478 15 14.25V8.21252",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.c899ab496e28840411708c433c8df6d6.svg";
export { ForwardRef as ReactComponent };